import type { BackendRouteDefinition } from '../types';

export const getPageVisitorsRoute = {
  transport: 'api',
  method: 'GET',
  path: '/admin/analytics/page-visitors',
  query: ({
    pagePath,
    monthsBack,
  }: {
    pagePath: string;
    monthsBack: number;
  }) => ({
    pagePath,
    monthsBack,
  }),
} as const satisfies BackendRouteDefinition;
